import {
  Row,
  Col,
  Form,
  Checkbox,
  Input,
  Space,
  Switch,
  Modal,
  Spin,
  Button,
  Card,
  Alert,
  Divider,
} from "antd";
import axios from "axios";
import React, {
  forwardRef,
  useImperativeHandle,
  useEffect,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { debounce } from "lodash";
import {
  update_temp_data_form_type,
  update_answer_call_form,
  update_cctanf_form,
  update_childcareneedlist_form,
  update_childcareonly_form,
  update_citidentitylist_form,
  update_csallprograms_form,
  update_csauthrep_form,
  update_cssummaryscreen_form,
  update_dcexpenselist_form,
  update_dvsass_form,
  update_emplistinclist_form,
  update_expeditedstatus_form,
  update_expenselist_form,
  update_famplanchildcare_form,
  update_householdstatuslist_form,
  update_icebt_form,
  update_icmawrs_form,
  update_indemoscreen_form,
  update_livingarrangement_form,
  update_mdcareexpenselist_form,
  update_mdexpenselist_form,
  update_medcondlist_form,
  update_narrative_form,
  update_noncompliancelist_form,
  update_noncustparentlist_form,
  update_otherprogramlist_form,
  update_pcscheduledlist_form,
  update_pregnancylist_form,
  update_purchasepreparelist_form,
  update_registration_form,
  update_relationshiplist_form,
  update_reportingpage_form,
  update_resourcelist_form,
  update_right_resp_form,
  update_runedbc_form,
  update_schoolattlist_form,
  update_screenpw_form,
  update_screenvr_form,
  update_tanfdt_form,
  update_tanfsuspensionbased_form,
  update_tanfwpcoop_form,
  update_timelimitsummary_form,
  update_todo_form,
  update_verificationslist_form,
  setErrorCount_answer_call_form,
  setErrorCount_cctanf_form,
  setErrorCount_childcareneedlist_form,
  setErrorCount_childcareonly_form,
  setErrorCount_citidentitylist_form,
} from "../../actions/search_slice";
import SearchEdit from "../CaseLookup/SearchEdit";
import { LAMBDAS } from "../../literals";
import {
  setErrorCount_csallprograms_form,
  setErrorCount_csauthrep_form,
  setErrorCount_cssummaryscreen_form,
  setErrorCount_dcexpenselist_form,
  setErrorCount_dvsass_form,
  setErrorCount_emplistinclist_form,
  setErrorCount_expeditedstatus_form,
  setErrorCount_expenselist_form,
  setErrorCount_famplanchildcare_form,
  setErrorCount_householdstatuslist_form,
  setErrorCount_icebt_form,
  setErrorCount_icmawrs_form,
  setErrorCount_indemoscreen_form,
  setErrorCount_livingarrangement_form,
  setErrorCount_mdcareexpenselist_form,
  setErrorCount_mdexpenselist_form,
  setErrorCount_medcondlist_form,
  setErrorCount_narrative_form,
  setErrorCount_noncompliancelist_form,
  setErrorCount_noncustparentlist_form,
  setErrorCount_otherprogramlist_form,
  setErrorCount_pcscheduledlist_form,
  setErrorCount_pregnancylist_form,
  setErrorCount_purchasepreparelist_form,
  setErrorCount_registration_form,
  setErrorCount_relationshiplist_form,
  setErrorCount_reportingpage_form,
  setErrorCount_resourcelist_form,
  setErrorCount_right_resp_form,
  setErrorCount_runedbc_form,
  setErrorCount_schoolattlist_form,
  setErrorCount_screenpw_form,
  setErrorCount_screenvr_form,
  setErrorCount_tanfdt_form,
  setErrorCount_tanfsuspensionbased_form,
  setErrorCount_tanfwpcoop_form,
  setErrorCount_timelimitsummary_form,
  setErrorCount_todo_form,
  setErrorCount_verificationslist_form,
} from "../../actions/search_slice";

const RetrieveTempData = forwardRef(({ agentName, agentId }, ref) => {
  // ({ onValuesChange, agentName, onOkay, onReset }, ref) => {

  const [form] = Form.useForm();
  const [modalOpen, setModalOpen] = useState(false);
  const [contactExist, setContactExist] = useState(true);
  const [alert_message, setAlertMsg] = useState(false);
  //Supervisor View
  const [getLastAgentUpdate, setLastAgentUpdate] = useState({
    "Last Update Details": [],
  });
  const [dataEdit, setDataEdit] = useState([]);
  const [fileName, getFileName] = useState("");
  const [contactId, setContactId] = useState("");
  const [caseNum, setCaseNum] = useState("");
  const [disableButton, setDisableButton] = useState(false);

  useImperativeHandle(ref, () => ({
    getFieldsError: form.getFieldsError,
    validateFields: form.validateFields,
    resetFields: form.resetFields,
    setFieldsValue: form.setFieldsValue,
    scrollToField: form.scrollToField,
    submit: form.submit,
    getFieldsValue: form.getFieldsValue,
    getFieldValue: form.getFieldValue,
  }));

  const dispatch = useDispatch();
  const formData = useSelector((state) => state.form.tempData_form_type);

  // const handleCancel = () => {
  //   console.log("cancelled");
  //   setModalOpen(false);
  //   form.setFieldsValue({ isExistingContact: true });
  //   setContactExist(true);
  // };

  const handleFormChange = debounce((changedValues) => {
    console.log("handleFormChange", changedValues);
    dispatch(update_temp_data_form_type(changedValues));
    // onValuesChange(formData);
    console.log("GET FIELDS VALUE1", changedValues["isExistingContact"]);
    // if (changedValues["isExistingContact"] === undefined) {
    //   setContactExist(true);
    //   setModalOpen(false);
    // } else if (!changedValues["isExistingContact"]) {
    //   setModalOpen(true);
    //   setContactExist(changedValues["isExistingContact"]);
    // } else {
    //   setContactExist(changedValues["isExistingContact"]);
    //   setModalOpen(false);
    // }
  }, 300);

  const onFinish = async (values) => {
    console.log("[Retrieve-CaseNumber]", values["case_num"]);
    let case_number = values["case_num"];
    let case_name = values["case_name"];
    console.log("[Case Lookup]", agentId);
    try {
      const { data: response } = await axios.get(
        LAMBDAS.GET_FORM_DETAILS +
          case_number +
          "&contactname=" +
          case_name +
          "&agentId=" +
          agentId
      );
      let resp_data = response.response;
      console.log("[get_contact_data][DATA][CaseLookUp]", resp_data);
      let forms = resp_data["form_details"];
      if (forms.length > 45) {
        forms.shift();
      }
      setContactId(resp_data["contactId"]);
      setCaseNum(resp_data["caseNumber"]);
      setDataEdit(forms);
      setDisableButton(true);
    } catch (error) {
      setAlertMsg(true);
      console.log("[get_contact_data][ERROR]", error);
    }
  };

  const onReset = () => {
    form.resetFields();
    setDataEdit([]);
    setDisableButton(false);
    dispatch(update_answer_call_form([]));
    dispatch(update_cctanf_form([]));
    dispatch(update_childcareneedlist_form([]));
    dispatch(update_childcareonly_form([]));
    dispatch(update_citidentitylist_form([]));
    dispatch(update_csallprograms_form([]));
    dispatch(update_csauthrep_form([]));
    dispatch(update_cssummaryscreen_form([]));
    dispatch(update_dcexpenselist_form([]));
    dispatch(update_dvsass_form([]));
    dispatch(update_emplistinclist_form([]));
    dispatch(update_expeditedstatus_form([]));
    dispatch(update_expenselist_form([]));
    dispatch(update_famplanchildcare_form([]));
    dispatch(update_expenselist_form([]));
    dispatch(update_householdstatuslist_form([]));
    dispatch(update_icebt_form([]));
    dispatch(update_icmawrs_form([]));
    dispatch(update_indemoscreen_form([]));
    dispatch(update_livingarrangement_form([]));
    dispatch(update_mdcareexpenselist_form([]));
    dispatch(update_mdexpenselist_form([]));
    dispatch(update_medcondlist_form([]));
    dispatch(update_narrative_form([]));
    dispatch(update_noncompliancelist_form([]));
    dispatch(update_noncustparentlist_form([]));
    dispatch(update_otherprogramlist_form([]));
    dispatch(update_pcscheduledlist_form([]));
    dispatch(update_pregnancylist_form([]));
    dispatch(update_purchasepreparelist_form([]));
    dispatch(update_registration_form([]));
    dispatch(update_relationshiplist_form([]));
    dispatch(update_reportingpage_form([]));
    dispatch(update_resourcelist_form([]));
    dispatch(update_right_resp_form([]));
    dispatch(update_runedbc_form([]));
    dispatch(update_schoolattlist_form([]));
    dispatch(update_screenpw_form([]));
    dispatch(update_screenvr_form([]));
    dispatch(update_tanfdt_form([]));
    dispatch(update_tanfsuspensionbased_form([]));
    dispatch(update_tanfwpcoop_form([]));
    dispatch(update_timelimitsummary_form([]));
    dispatch(update_todo_form([]));
    dispatch(update_verificationslist_form([]));
    dispatch(setErrorCount_answer_call_form(0));
    dispatch(setErrorCount_cctanf_form(0));
    dispatch(setErrorCount_childcareneedlist_form(0));
    dispatch(setErrorCount_childcareonly_form(0));
    dispatch(setErrorCount_citidentitylist_form(0));
    dispatch(setErrorCount_registration_form(0));
    dispatch(setErrorCount_csallprograms_form(0));
    dispatch(setErrorCount_cssummaryscreen_form(0));
    dispatch(setErrorCount_csauthrep_form(0));
    dispatch(setErrorCount_dcexpenselist_form(0));
    dispatch(setErrorCount_dvsass_form(0));
    dispatch(setErrorCount_emplistinclist_form(0));
    dispatch(setErrorCount_expeditedstatus_form(0));
    dispatch(setErrorCount_expenselist_form(0));
    dispatch(setErrorCount_famplanchildcare_form(0));
    dispatch(setErrorCount_householdstatuslist_form(0));
    dispatch(setErrorCount_icebt_form(0));
    dispatch(setErrorCount_icmawrs_form(0));
    dispatch(setErrorCount_indemoscreen_form(0));
    dispatch(setErrorCount_livingarrangement_form(0));
    dispatch(setErrorCount_mdcareexpenselist_form(0));
    dispatch(setErrorCount_mdexpenselist_form(0));
    dispatch(setErrorCount_medcondlist_form(0));
    dispatch(setErrorCount_narrative_form(0));
    dispatch(setErrorCount_noncompliancelist_form(0));
    dispatch(setErrorCount_noncustparentlist_form(0));
    dispatch(setErrorCount_otherprogramlist_form(0));
    dispatch(setErrorCount_pcscheduledlist_form(0));
    dispatch(setErrorCount_pregnancylist_form(0));
    dispatch(setErrorCount_purchasepreparelist_form(0));
    dispatch(setErrorCount_relationshiplist_form(0));
    dispatch(setErrorCount_reportingpage_form(0));
    dispatch(setErrorCount_resourcelist_form(0));
    dispatch(setErrorCount_right_resp_form(0));
    dispatch(setErrorCount_runedbc_form(0));
    dispatch(setErrorCount_schoolattlist_form(0));
    dispatch(setErrorCount_screenpw_form(0));
    dispatch(setErrorCount_screenvr_form(0));
    dispatch(setErrorCount_tanfdt_form(0));
    dispatch(setErrorCount_tanfsuspensionbased_form(0));
    dispatch(setErrorCount_tanfwpcoop_form(0));
    dispatch(setErrorCount_timelimitsummary_form(0));
    dispatch(setErrorCount_todo_form(0));
    dispatch(setErrorCount_verificationslist_form(0));
    setAlertMsg(false);
    // dispatch(setErrorCount_citidentitylist_form(0));
  };

  return (
    <Card>
      <Form
        form={form}
        // onValuesChange={handleFormChange}
        labelAlign="justify"
        layout="vertical"
        labelWrap
        wrapperCol={{
          flex: 1,
        }}
        onFinish={onFinish}
      >
        {alert_message ? (
          <Alert
            message="Data does not exist. Please try again."
            banner
            closable
            showIcon
            type="error"
            style={{ marginBottom: "15px" }}
          />
        ) : (
          ""
        )}

        <Form.Item
          name="case_num"
          label="Case Number"
          // label="Enter ContactId and Agent FullName(ex. contactidherejanedoe)"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input placeholder="Please enter Case Number here." />
        </Form.Item>
        <Form.Item
          name="case_name"
          label="Case Name"
          // label="Enter ContactId and Agent FullName(ex. contactidherejanedoe)"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input placeholder="Please enter Case Name here." />
        </Form.Item>

        <Row>
          <Col span={12}>
            <Button key="reset" onClick={onReset} style={{ width: "100%" }}>
              RESET
            </Button>
          </Col>
          <Col span={12}>
            <Button
              key="ok"
              type="primary"
              htmlType="submit"
              // onClick={onSubmit}
              style={{ width: "100%" }}
              disabled={disableButton}
            >
              SUBMIT
            </Button>
          </Col>
        </Row>
      </Form>

      <Divider></Divider>
      {dataEdit.length != 0 ? (
        <SearchEdit
          dataToEdit={dataEdit}
          caseNum={caseNum}
          contactId={contactId}
          agentName={agentName}
        />
      ) : (
        // <SearchEdit
        //   dataToEdit={dataEdit}
        //   caseNum={caseNum}
        //   contactId={contactId}
        //   agentName={agentName}
        // />
        ""
      )}
      {/* <SearchEdit
          isEditing={isEditing}
          dataToEdit={dataEdit}
          lastAgentUpdate={getLastAgentUpdate}
          fileName={fileName}
          contactID={contactID}
          currentFileID={contactId_file}
        /> */}
    </Card>

    //   <Modal
    //     title=""
    //     centered
    //     open={modalOpen}
    //     closable={true}
    //     footer={[
    //       <Button key="reset" onClick={onReset}>
    //         RESET
    //       </Button>,
    //       <Button key="ok" type="primary" onClick={onOkay}>
    //         SUBMIT
    //       </Button>,
    //     ]}
    //     // onOk={() => setModal2Open(false)}
    //     // onCancel={() => setModal2Open(false)}
    //   >

    //   </Modal>
  );
});
export default RetrieveTempData;
